import { render, staticRenderFns } from "./MunicipalityLogo.vue?vue&type=template&id=505bbd8a&scoped=true&"
import script from "./MunicipalityLogo.vue?vue&type=script&lang=ts&"
export * from "./MunicipalityLogo.vue?vue&type=script&lang=ts&"
import style0 from "./MunicipalityLogo.vue?vue&type=style&index=0&id=505bbd8a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505bbd8a",
  null
  
)

export default component.exports